import "./index.css";

import { Suspense, useMemo, lazy } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxStoreProvider } from "react-redux";
import { ThemeProvider, DragProvider } from "@peak-security-suite/ui-elements";
import reduxStore from "@services/reduxStore";
import GlobalLoading from "@components/main/GlobalLoading";

const App = lazy(() => import("@components/main/App"));

function Root() {
  const loadedAt = useMemo(() => new Date(), []);

  return (
    <ThemeProvider fontFamily={'"Inter", sans-serif'}>
      <DragProvider>
        <ReduxStoreProvider store={reduxStore}>
          <Suspense fallback={<GlobalLoading loadedAt={loadedAt} />}>
            <App loadedAt={loadedAt} />
          </Suspense>
        </ReduxStoreProvider>
      </DragProvider>
    </ThemeProvider>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);
